import React, { useState, useEffect, useRef } from "react";

const MarathTypingHelper = ({
    position,
    isOpen,
    onRequestClose,
    updateModalValue,
    activeInput
}) => {
    const modalStyle = {
        top: position.top - 85 + "px",
        left: position.left + "px",
        width: "350px",
        height: "400px",
        padding: "0px",
        marginTop: "0px",
        display: 'block'
    };
    const inputRef = useRef(null);
    const [userInput, setUserInput] = useState("");
    const [marathiOptions, setMarathiOptions] = useState([]);

    const handleInputChange = async (event) => {
        const valueInput = event.target.value;
        setUserInput(valueInput);
        if (valueInput.length < 1) return
        const res = await fetch(`https://inputtools.google.com/request?text=${valueInput}&itc=mr-t-i0-und&num=13&cp=0&cs=1&ie=utf-8&oe=utf-8&app=demopage`)
        const data = await res.json();
        let resultantArray = data[1][0][1]
        resultantArray.splice(1, 0, valueInput);

        setMarathiOptions(resultantArray);
    };

    useEffect(() => {
        if (isOpen) {
            inputRef.current.focus();
        }
        setUserInput(activeInput?.key || "")
    }, [isOpen]);

    const handleKeyUp = (e) => {
        if (e.key == " ") {
            onRequestClose();
            updateModalValue(marathiOptions[0] + ' ');
            setUserInput("");
        }
    };
    const handleSelect = (item) => {
        onRequestClose();
        updateModalValue(item + " ");
        setUserInput("");
    }
    return (
        <div className={`modal fade ${isOpen ? "open" : "closed"}`} style={modalStyle}>
            <div className="modal-content" style={{ position: "absolute", top: "4px", left: "0px", zIndex: 1000 }}>
                <div className="form-group">
                    <input
                        className="form-control"
                        type="text"
                        ref={inputRef}
                        value={userInput}
                        onChange={handleInputChange}
                        placeholder="येथे आपली माहिती भरा..."
                        onKeyUp={handleKeyUp}
                    />

                    <div>
                        {marathiOptions && marathiOptions.map((item, index) => {
                            return (<><p key={index} onClick={() => handleSelect(item)}>{item}</p></>);
                        })}
                    </div>
                </div>
                <button className="btn btn-primary" type="button"
                    onClick={onRequestClose}
                >
                    Close Modal
                </button>
            </div>
        </div>
    )
}

export default MarathTypingHelper;